import React, { useState, Suspense, lazy } from 'react';
import { ArrowRight } from 'lucide-react';
import PilotForm from './PilotForm';

const Spline = lazy(() => import('@splinetool/react-spline'));

const Hero = () => {
  const [showPilotForm, setShowPilotForm] = useState(false);

  return (
    <section className="min-h-screen bg-black relative overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 pt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
          {/* Left */}
          <div className="space-y-8">
            <div>
              <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-400/10 border border-cyan-400/30 text-xs tracking-[0.25em] uppercase text-cyan-300 font-semibold mb-8">
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-300 animate-pulse" />
                Hiko · NZD Payment Rail · Phase 1
              </span>

              <h1 className="display-huge text-white leading-[1.02] mb-6">
                The infrastructure designed to <span className="text-cyan-300">stop wealth leaking</span> out of Aotearoa.
              </h1>

              <p className="body-large text-white/75 leading-relaxed max-w-2xl mb-6">
                <span className="text-cyan-300">Hiko</span> is a NZ dollar payment service
                operated by Māori Fintech that connects Iwi, community organisations, businesses,
                members and approved merchants reducing reliance on expensive offshore
                payment networks.
              </p>

              <button
                onClick={() => setShowPilotForm(true)}
                data-testid="hero-more-info-link"
                className="inline-flex items-center gap-2 text-cyan-300 hover:text-cyan-200 text-base font-medium border-b border-cyan-300/40 hover:border-cyan-200 pb-1 transition-colors"
              >
                Get in touch
                <ArrowRight size={16} />
              </button>
            </div>
          </div>

          {/* Right - Spline */}
          <div className="relative">
            <div className="w-full h-[400px] sm:h-[520px] lg:h-[700px] relative overflow-visible">
              <Suspense
                fallback={
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-cyan-900/20 to-purple-900/20 border border-cyan-400/20">
                    <div className="text-center">
                      <div className="w-20 h-20 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                      <p className="text-cyan-400 font-semibold mb-2">Loading 3D scene</p>
                      <p className="text-white/40 text-sm">First load may take a moment...</p>
                    </div>
                  </div>
                }
              >
                <Spline
                  scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
                  style={{ width: '100%', height: '100%' }}
                />
              </Suspense>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-br from-black via-black to-gray-900 opacity-90 -z-10" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-cyan-400/5 rounded-full blur-3xl -z-10" />

      {showPilotForm && (
        <PilotForm isOpen={showPilotForm} onClose={() => setShowPilotForm(false)} />
      )}
    </section>
  );
};

export default Hero;
